const SELF_CHECK_API_ENDPOINT =
  process.env.REACT_APP_NVFO_API_ENDPOINT || "http://localhost:4000/api/v1";

export type SelfCheckLeadPayload = {
  name: string;
  phone?: string;
  email?: string;
  checkedCount: number;
  selections: Record<string, string[]>;
};

export const submitSelfCheckLead = async (payload: SelfCheckLeadPayload) => {
  const response = await fetch(`${SELF_CHECK_API_ENDPOINT}/leads`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ type: "self_check", ...payload }),
  });
  if (!response.ok) {
    throw new Error(`self-check lead submission failed: ${response.status}`);
  }
};
